export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_SEARCH_RETURN = "SET_SEARCH_RETURN";
export const LOADING = "LOADING";
export const SHOW_SUCCESS_MESSAGE = "SHOW_SUCCESS_MESSAGE";
